<template>
  <div class="header">
    <div class="wrapper">
      <a-row :gutter="16" type="flex">
        <a-col>
          <span class="t-label">Filtruj:</span>
        </a-col>

        <a-col>
          <a-select
            class="c-ghost-input"
            showSearch
            v-model="languages__language"
            :options="languages"
            allowClear
            placeholder="Język"
            optionFilterProp="children"
            style="width: 176px"
          />
        </a-col>

        <a-col>
          <a-select
            class="c-ghost-input"
            showSearch
            v-model="languages__levels"
            :options="levels"
            mode="multiple"
            allowClear
            placeholder="Poziom"
            optionFilterProp="children"
            style="width: 180px"
          />
        </a-col>
      </a-row>

      <div>
        <a-input-search
          v-model="search"
          placeholder="Szukaj"
          style="width: 248px"
          class="c-ghost-input"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ListHeader from '@/components/layout/ListHeader'
import { Language } from '@/api'

export default {
  queryModels: ['search', 'languages__language', 'languages__levels'],
  extends: ListHeader,
  data() {
    return {
      languages: [],
      levels: []
    }
  },
  created() {
    Language.all().then(res => {
      this.languages = res.data.results.map(language => ({
        label: language.name,
        value: language.id
      }))
    })
    Language.levels().then(res => {
      this.levels = res.data
    })
  }
}
</script>
